var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 51,
    viewBox: "0 0 56 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3107 0.75C38.793 0.75 0 1.00996 0 0.75C0 0.75 0 33.8838 0 38.2981C0 43.2192 5.46149 44.2006 5.95928 44.2802C6.00177 44.6833 6.75148 50.75 13.5566 50.75C16.946 50.75 56 50.75 56 50.75C56 50.75 56 17.7744 56 11.6552C56 4.64537 51.8285 0.75 45.3107 0.75ZM12.7533 35.2663H8.98444C8.98444 35.2663 8.98444 22.3761 8.98444 20.2551C8.98444 15.8499 12.7533 15.8499 12.7533 15.8499V35.2673V35.2663ZM43.7931 35.2663V15.8499H26.8977C27.1385 15.8549 30.6533 16.001 30.6533 20.2551V35.2663H26.8845V15.8499H12.7968C12.7968 15.8499 12.7968 12.0966 17.2202 12.0966H22.197C25.547 12.0966 26.3594 14.2478 26.5577 15.2927C26.755 14.2478 27.5685 12.0966 30.9184 12.0966H39.4587C43.8821 12.0966 43.8821 15.8499 43.8821 15.8499H43.8062C44.047 15.8549 47.5609 16.001 47.5609 20.2551C47.5609 22.3761 47.5609 35.2663 47.5609 35.2663H43.7921H43.7931Z",
    fill: "url(#paint0_linear_8581_9274)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8581_9274",
    x1: 28,
    y1: 2.00548,
    x2: 28,
    y2: 52.0055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#64FF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7BAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#DB1461"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogoMini);
export default __webpack_public_path__ + "static/media/dark-logo-mini.a235fb8df52154b3a931eb8f819d6767.svg";
export { ForwardRef as ReactComponent };